// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:20
import { Sector_abstract } from './../abstract/SagaBase/Sector_abstract';
export class Sector extends Sector_abstract {}
